function isIOSDevice() {
	return (
		/iPhone|iPad|iPod/i.test(navigator.userAgent) ||
		(navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
	);
}

function openIndividualMenuRedesigned(menuBlock) {
	const $menuBlock = $(menuBlock);
	const $mainMenuItems = $(
		'.mobile-megamenu-left-section .individual-menu-item'
	);

	if(!$menuBlock.hasClass('menu-with-no-sub-menu')) {
		$('.featured_image_slider_container').hide();
	} else {
		// $('.featured_image_slider_container').show();
	}

	// Remove 'open' class from all menu items and add to target in one operation
	$mainMenuItems.removeClass('open');
	$menuBlock.addClass('open');

	const subMenuClassName = $menuBlock.attr('sub-menu-class');
	sessionStorage.removeItem('subMenuPosition');

	if (!subMenuClassName) return;

	const $subMenus = $('.mobile-megamenu-right-section .sub-menu-list');
	const $targetSubMenu = $(`.${subMenuClassName}`);

	// Remove 'open' class from all sub-menus and add to target in one operation
	$subMenus.removeClass('open');
	$targetSubMenu.addClass('open');

	// Store sub-menu-class in SS for menu state management
	sessionStorage.setItem('subMenuClass', subMenuClassName);
	$(".submenu-active").removeClass("submenu-active");
}

function toggleSubMenuRedesigned(subMenuTitle) {
	const $subMenu = $(subMenuTitle).parent();
	if (!$subMenu.length) return;

	const isOpen = $subMenu.hasClass('open');

	// Toggle current menu and store position in SS
	if (!isOpen) {
		$subMenu.addClass('open').find('.sub-sub-menu-list').slideDown(200);
	} else {
		$subMenu.removeClass('open').find('.sub-sub-menu-list').slideUp(200);
	}

	$(".submenu-active").removeClass("submenu-active");
}

function initializeFeaturedImageSlider() {
    $('.featured_image_slider_container').slick({
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
    });
}

$(document).ready(function() {
    initializeFeaturedImageSlider();
    
	const subMenuClass = sessionStorage.getItem('subMenuClass');
	const subMenuUrl = sessionStorage.getItem('subMenuUrl');

	if (subMenuClass) {
		if($(`[sub-menu-class="${subMenuClass}"]`).hasClass('menu-with-no-sub-menu')) {
			if(window.location.href.includes($(`[sub-menu-class="${subMenuClass}"] a`).attr("href"))) {
				$(`[sub-menu-class="${subMenuClass}"]`).click();
			}
		} else {
				$(`[sub-menu-class="${subMenuClass}"]`).click();
		}
	}

	if (subMenuUrl) {
		$(`.sub-menu-list.${subMenuClass} [href="${subMenuUrl}"]`)
			.closest(".sub-menu-item")
			.find(".sub-menu-title-redesigned")
			.click();
	}

	$(".header-megamenu-container__mobile-redesigned .sub-sub-menu-item a").on("click", function() {
		sessionStorage.setItem("subMenuUrl", $(this).attr("href"));
	});

	$(".mobile-megamenu-right-section .sub-menu-list a").on("click", function(e) {
		e.preventDefault();
		$(".submenu-active").removeClass("submenu-active");
		$(this).addClass("submenu-active");
		setTimeout(() => {
			window.location.href = $(this).attr("href");
		}, 500);
	});

	$(".sub-menu-title-redesigned a, .header-megamenu-container__mobile-redesigned .sub-menu-item > a").on("click", function() {
		sessionStorage.removeItem("subMenuUrl");
	});

	$(".menu-with-no-sub-menu a").on("click", function(e) {
		e.preventDefault();
		sessionStorage.removeItem("subMenuUrl");
		setTimeout(() => {
			window.location.href = $(this).attr("href");
		}, 500);
		// initializeFeaturedImageSlider();
	});

	$('form > .search-form > .search-input')
		.on('focus', function() {
			console.log('=====Focus=====');
			if (isIOSDevice()) {
				$('body').css('touch-action', 'none');
			} else {
				$('body').css('overflow-y', 'hidden');
			}
		})
		.on('blur', function() {
			console.log('=====Defocus=====');
			if (isIOSDevice()) {
				$('body').css('touch-action', 'auto');
			} else {
				$('body').css('overflow-y', 'auto');
			}
		});

	$('body').addClass('redesigned-mobile-megamenu-js-executed');
});